import styleInject from './../../../externals/style-inject/dist/style-inject.es.js';

var css_248z = ".PaymentAlerts-module_paymentAlerts__XzIeZ {\n  margin-bottom: var(--pp-spacing-xs);\n}\n\n.PaymentAlerts-module_errorAlert__1u8e8 {\n  margin-bottom: var(--pp-spacing-m);\n}";
var styles = {"paymentAlerts":"PaymentAlerts-module_paymentAlerts__XzIeZ","errorAlert":"PaymentAlerts-module_errorAlert__1u8e8"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=PaymentAlerts.module.scss.js.map
